module.exports = __webpack_public_path__ + "img/gb-nir.b9f2baa0.svg";